// import { useMutation, useQuery } from "@tanstack/react-query";
import { useSnackbar } from '../stateless/SnackBarProvider';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useChoiceGroupApi } from '../../Hooks/useChoiceGroupApi';


export const UseCreateChoiceGroup = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { createChoiceGroup } = useChoiceGroupApi();
  return useMutation({
    mutationKey: ['CreateChoiceGroup'],
    mutationFn: ({ data }: { data: any; storeId: string }) => {
      return createChoiceGroup(data);
    },
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'ChoiceGroup created successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getChoiceGroup'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to create ChoiceGroup',
        'error'
      );
    },
  });
};

export const usePatchChoiceGroup = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { getToggleStatus } = useChoiceGroupApi();

  return useMutation({
    mutationKey: ['PatchChoiceGroup'],
    mutationFn: ({ id, data }: { id: string[]; data: any }) =>
      getToggleStatus({ id, status: data.status }),
    onSuccess: (_response, variables) => {
      const action =
        variables.data.status === 'unblocked' ? 'unblocked' : 'blocked';
      showMessage(`Choice Group ${action} successfully`, 'success');
      queryClient.invalidateQueries({
        queryKey: ['getChoiceGroup'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type ||
        'Failed to block the Choice Group',
        'error'
      );
    },
  });
};

export const useDeleteChoiceGroup = () => {
  const queryClient = useQueryClient();
  const { deleteChoiceGroup } = useChoiceGroupApi();
  const { showMessage } = useSnackbar();

  return useMutation({
    mutationKey: ['DeleteChoiceGroup'],
    mutationFn: (ids: string[]) => {
      return deleteChoiceGroup(ids);
    },
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'ChoiceGroup deleted successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getChoiceGroup'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to deleted ChoiceGroup',
        'error'
      );
    },
  });
};

type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
};

export const useAllChoiceGroup = (queryParams: Params) => {
  const { getAllChoiceGroup } = useChoiceGroupApi();

  const {data,isLoading: isFetching,refetch,isRefetching,error,isError} = useQuery({
    queryKey: ['getChoiceGroup',queryParams],
    queryFn: () => {
      // Always inject merchantId from localStorage if not present
      return getAllChoiceGroup({
        ...queryParams,
      });
    },
    retry: false,
  });

  return {
    data,
    isLoading:isFetching || isRefetching,
    refetch,
    error,isError
  };
};

export const useEditChoiceGroup = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { editChoiceGroup } = useChoiceGroupApi();

  return useMutation({
    mutationKey: ['EditSubAdmin'],
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      editChoiceGroup(id, data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'ChoiceGroup Updated successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getChoiceGroup'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type ||
        'Failed to update the ChoiceGroup',
        'error'
      );
    },
  });
};
